var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBottomLeftBorder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 0.5H23.75V23.5H8.25C4.10786 23.5 0.75 20.1421 0.75 16V0.5Z",
    fill: "#FAFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 0.5H23.75V23.5H8.25C4.10786 23.5 0.75 20.1421 0.75 16V0.5Z",
    stroke: "#939393"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.53091 18.7197C5.31584 18.5046 5.25548 18.2364 5.24256 17.9828C5.23061 17.7483 5.25712 17.457 5.28695 17.1292L5.35877 16.3391C5.4093 15.783 5.45164 15.317 5.53342 14.9754C5.61523 14.6336 5.77329 14.2535 6.18372 14.1049C6.59415 13.9563 6.95889 14.1471 7.24055 14.3573C7.50824 14.5571 7.82044 14.866 8.18983 15.2352L12.2646 11.1604C12.4924 10.9327 12.8617 10.9327 13.0895 11.1604C13.3173 11.3882 13.3173 11.7576 13.0895 11.9854L9.01478 16.0602C9.38426 16.4298 9.69343 16.7422 9.89328 17.0101C10.1035 17.2917 10.2943 17.6565 10.1457 18.0669C9.99712 18.4773 9.61701 18.6354 9.27524 18.7172C8.93352 18.799 8.46756 18.8413 7.9115 18.8918L7.12142 18.9637C6.79361 18.9935 6.50231 19.02 6.26785 19.0081C6.01425 18.9951 5.74598 18.9348 5.53091 18.7197Z",
    fill: "#141B34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomLeftBorder);
export default __webpack_public_path__ + "static/media/BottomLeftBorder.ff023101c67b755e3b65a9ff90de22d0.svg";
export { ForwardRef as ReactComponent };